import React from 'react';

// Backend (productService.getLowMarginProducts) zwraca produkty ponizej tego progu marzy.
// Progi kolorow wyprowadzamy z niego, zeby caly zakres (czerwony/zolty/zielony) byl osiagalny.
const LOW_MARGIN_THRESHOLD = 15;

const LowMarginReport = ({ lowMarginProducts }) => {
  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
      <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
        <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>⚠️ Produkty z niską marżą</h5>
      </div>
      <div style={{ padding: '0.75rem' }}>
        {lowMarginProducts.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem' }}>
              <thead>
                <tr>
                  <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.7rem' }}>Produkt</th>
                  <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.7rem' }}>Cena zakupu</th>
                  <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.7rem' }}>Cena sprzedaży</th>
                  <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.7rem' }}>Marża</th>
                  <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.7rem' }}>Zysk</th>
                </tr>
              </thead>
              <tbody>
                {lowMarginProducts.map((product) => {
                  // Koszt = FIFO (to samo zrodlo co marza_procent z backendu), zeby
                  // Cena zakupu / Marza / Zysk byly SPOJNE. Wczesniej kolumny brały
                  // koszt z karty produktu, a marza z FIFO -> rozjazd (np. zysk +, marza -).
                  const cenaZakupu = parseFloat(
                    product.cena_zakupu_fifo != null ? product.cena_zakupu_fifo
                      : (product.cena_zakupu_netto || product.cena_zakupu_brutto || product.cena_zakupu)
                  ) || 0;
                  const cenaSprzedazy = parseFloat(product.cena_sprzedazy_netto || product.cena_brutto || product.cena_sprzedazy) || 0;
                  // Marza liczona wzgledem ceny SPRZEDAZY (model prawdziwej marzy), nie narzutu wzgledem zakupu.
                  // marza_procent == 0 to prawdziwa wartosc (nie brak), wiec != null zamiast falsy ||.
                  const marza = product.marza_procent != null
                    ? Number(product.marza_procent)
                    : (cenaSprzedazy > 0 ? (((cenaSprzedazy - cenaZakupu) / cenaSprzedazy) * 100) : 0);
                  const zysk = cenaSprzedazy - cenaZakupu;

                  return (
                    <tr key={product.id}>
                      <td style={{ padding: '0.3rem', borderBottom: '1px solid var(--bg)' }}>{product.nazwa}</td>
                      <td style={{ padding: '0.3rem', borderBottom: '1px solid var(--bg)' }}>{cenaZakupu.toFixed(2)} zł</td>
                      <td style={{ padding: '0.3rem', borderBottom: '1px solid var(--bg)' }}>{cenaSprzedazy.toFixed(2)} zł</td>
                      <td style={{ padding: '0.3rem', borderBottom: '1px solid var(--bg)' }}>
                        <span style={{
                          backgroundColor: marza < LOW_MARGIN_THRESHOLD / 3 ? 'var(--danger)' : marza < (LOW_MARGIN_THRESHOLD * 2) / 3 ? 'var(--warning)' : 'var(--success)',
                          color: '#fff' ,
                          padding: '0.15rem 0.3rem',
                          borderRadius: '0.25rem',
                          fontSize: '0.65rem'
                        }}>
                          {marza.toFixed(1)}%
                        </span>
                      </td>
                      <td style={{
                        padding: '0.3rem',
                        borderBottom: '1px solid var(--bg)',
                        color: zysk >= 0 ? 'var(--success)' : 'var(--danger)'
                      }}>
                        {zysk.toFixed(2)} zł
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--text-muted)' }}>Brak produktów z niską marżą</div>
        )}
      </div>
    </div>
  );
};

export default LowMarginReport;
